import React, { useEffect, useState } from "react";
import useSize from "../../../../Utils/useSize/useSize";
import TopHeader from "./TopHeader";
import HeaderAccount from "./HeaderAccount";
import toast from "react-hot-toast";
import Backend from "../../../../Backend/Backend";
import moment from "moment";

import LedgerCard from "./LedgerCard";

import Loading from "../../../../Utils/Loading/Loading";
import NotFound from "../../../../Utils/NotFound/NotFound";

const backend = await new Backend().init();

export default function LedgerScreen() {
  const windowSize = useSize();

  const [loading, setLoading] = useState(false);

  const [ledger, setLedger] = useState([]);
  const [ledger_search, setLedger_Search] = useState([]);

  const [deposit, setDeposit] = useState(0);
  const [withdraw, setWithdraw] = useState(0);

  const [deposit_wallet, setDepositWallet] = useState(0);
  const [withdraw_wallet, setWithdrawWallet] = useState(0);

  const [credit, setCredit] = useState(0);
  const [pl, setPl] = useState(0);

  const [nse_cash, setNseCash] = useState(0);

  const [date_start, setDate_Start] = useState(moment().startOf("week"));
  const [date_end, setDate_End] = useState(moment().endOf("week"));

  useEffect(() => {
    loadLedger();
  }, []);

  const loadLedger = () => {
    setLoading(true);
    let data = {
      server: localStorage.getItem("server"),
      id: localStorage.getItem("id"),
      username: localStorage.getItem("username"),
      token: localStorage.getItem("token"),
      ledger_id: localStorage.getItem("id"),
    };

    backend.load_ledger(data).then((r) => {
      setLoading(false);
      if (r.error === "False") {
        setLedger(r.ledger);
        setLedger_Search(r.ledger);
        setWithdraw(r.withdraw);
        setDeposit(r.deposit);

        setWithdrawWallet(r.withdraw_wallet);
        setDepositWallet(r.deposit_wallet);

        setCredit(r.credit);

        setPl(r.net_pl);

        setNseCash(r.nse_cash);
      } else {
        toast.error(r.message);
      }
    });
  };

  const loadLedgerDate = (a, b) => {
    setDate_Start(a);
    setDate_End(b);

    setLoading(true);
    let data = {
      server: localStorage.getItem("server"),
      id: localStorage.getItem("id"),
      username: localStorage.getItem("username"),
      token: localStorage.getItem("token"),

      start: a === undefined ? date_start : a,
      end: b === undefined ? date_end : b,
      ledger_id: localStorage.getItem("id"),
    };

    backend.load_ledger(data).then((r) => {
      setLoading(false);
      if (r.error === "False") {
        setLedger(r.ledger);
        setLedger_Search(r.ledger);
        setWithdraw(r.withdraw);
        setDeposit(r.deposit);

        setWithdrawWallet(r.withdraw_wallet);
        setDepositWallet(r.deposit_wallet);

        setCredit(r.credit);

        setPl(r.net_pl);

        setNseCash(r.nse_cash);
      } else {
        toast.error(r.message);
      }
    });
  };

  const contentHeight = windowSize[1] - 220;

  return (
    <div className="bg-[var(--background)]">
      {/* 🔹 Header */}
      <TopHeader loadLedgerDate={loadLedgerDate} />
      <HeaderAccount
        nse_cash={nse_cash}
        pl={pl}
        deposit_wallet={deposit_wallet}
        withdraw_wallet={withdraw_wallet}
        deposit={deposit}
        credit={credit}
        withdraw={withdraw}
      />

      {/* 📜 Ledger Entries */}
      <div className="space-y-2 p-4">
        <div
          key={loading ? "loading" : "loaded"}
          style={{
            height: contentHeight,
            display: "flex",
            flexDirection: "column",
          }}
        >
          {loading ? (
            <div className="flex items-center justify-center w-full h-full">
              <Loading height={contentHeight} />
            </div>
          ) : ledger.length > 0 ? (
            <div
              className="overflow-y-auto custom-scrollbar"
              style={{
                height: contentHeight,
                overflowY: "scroll",
                scrollBehavior: "smooth",
                paddingBottom: 200,
              }}
            >
              {ledger.map((item, index) => (
                <LedgerCard
                  key={item.id || index}
                  item={item}
                  index={index + 1}
                  reload={loadLedger}
                />
              ))}
            </div>
          ) : (
            <NotFound
              small
              height={contentHeight}
              title="Nothing here"
              subtext="No ledger found."
            />
          )}
        </div>
      </div>
    </div>
  );
}
